import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import CheckIcon from '@mui/icons-material/Check';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Typography from '@mui/material/Typography';
import {
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Collapse,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import NavigateSnackbar from '../navigateSnackbar/NavigateSnackbar';
import { TestStatus } from '../../utils/constants';

import {
  ParentBox,
  reportStyles,
} from './style';
import { useCommonContext } from '../header/context';
import Breadcrumb from '../breadcrumbs/Breadcrumb';
import { parseDate } from '../dashboard/utils';
import FullScreenModal from '../reportList/FullScreenModal';

const counter = {
  mount: 0,
  handleChange: 0,
  onTestSuitClick: 0,
};

const XmlReport = ({ data }) => {
  const style = reportStyles();
  const [snackbar, setSnackbar] = useState({
    state: false,
    navigateText: '',
    message: '',
    severity: 'success',
  });
  const [active, setActive] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedTests, setSelectedTests] = useState([]);
  const {
    selectedfilter,
    setSelectedFilter,
  } = useCommonContext();
  const onTestSuitClick = (tests) => {
    counter.onTestSuitClick += 1;
    setSelectedTests(tests);
    setOpenDrawer(true);
  };

  useEffect(() => {
    counter.mount += 1;
  }, []);

  const renderData = (testData) => {
    let listData = testData;
    if (testData?.test) {
      if (!Array.isArray(testData?.test)) {
        listData = [testData?.test];
      } else {
        listData = testData?.test;
      }
    }
    return listData?.map((details, i) => {
      const originalItem = testData?.test ? details : details?.test;

      const itemArray = Array.isArray(originalItem) ? originalItem : [originalItem];

      return itemArray?.map((item) => {
        const methods = item?.class?.['test-method'];
        const failedTest = methods?.length ? methods.filter(
          (a) => a.status === TestStatus.FAIL,
        ) : [];
        if (selectedfilter === TestStatus.PASS && failedTest.length) {
          return null;
        }
        if (selectedfilter === TestStatus.FAIL && failedTest.length === 0) {
          return null;
        }

        return (
          <>
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => onTestSuitClick(item?.class['test-method'])}
              key={item?.name}
            >
              <ListItemIcon>
                <SearchIcon className={style.searchicon} />
                {failedTest.length ? (
                  <ReportProblemIcon
                    className={style.failIcon}
                  />
                ) : (
                  <CheckIcon sx={{ color: 'green', mr: 2 }} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={item?.name}
                secondary={item?.class?.name}
              />

              <Typography
                component="div"
                className={style.accordianTime}
              >
                <Typography
                  component="h1"
                  className={style.accordianHeader}
                >
                  Test
                </Typography>
                {
                  failedTest.length ? <Tooltip title="Failed">
                    <Button
                      variant="contained"
                      className={style.failedlistButton}
                    >
                      1
                    </Button>
                  </Tooltip> : <Tooltip title="Passed">
                    <Button
                      variant="contained"
                      className={style.testlistButton}
                    >
                      1
                    </Button>
                  </Tooltip>
                }
                <Button>
                  <Tooltip title="Show all details">
                    <FormatAlignLeftIcon />
                  </Tooltip>
                </Button>
              </Typography>
            </ListItemButton>
            {i !== listData?.length - 1 && (
              <Divider />
            )}
          </>
        );
      });
    });
  };

  return (
    <>
      <ParentBox>
        <Grid>
          <Breadcrumb data={['View Xml Report']} />
        </Grid>
        <Grid item sm={12} xs={12}>
          {data && (
            <List
              sx={{ width: '100%', bgcolor: 'background.paper' }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              <>
                <ListItem>

                  <IconButton onClick={() => setActive((pre) => !pre)}>
                    {active ? (
                      <ExpandMore />
                    ) : (
                      <ChevronRightIcon />
                    )}
                  </IconButton>
                  <ListItemIcon>
                    <SummarizeIcon sx={{ color: '#3f6398', mr: 2 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={data?.testingResults['testng-results']?.suite?.name || 'Smoke test'}
                  />
                  <ListItemText
                    primary={parseDate(data?.testingResults['testng-results']?.suite['started-at'] || data?.testingResults['testng-results']?.suite[0]['started-at'])}
                  />
                  <Typography
                    component="div"
                    className={style.reportHeader}
                  >
                    <Tooltip title="Company">
                      <Typography
                        component="h1"
                        className={style.reportTime}
                      >
                        {data?.companyId}
                      </Typography>
                    </Tooltip>
                    <Tooltip
                      title="Project"
                    >
                      <Typography
                        component="h1"
                        className={style.reportTime}
                      >
                        {data?.projectId}
                      </Typography>
                    </Tooltip>
                    <Tooltip title="Passed">
                      <Button
                        variant="contained"
                        className={style.testButton}
                        onClick={() => {
                          setSelectedFilter(TestStatus.PASS);
                          setActive(true);
                        }}
                      >
                        {data?.testingResults['testng-results']?.passed}
                      </Button>
                    </Tooltip>
                    <Tooltip title="Failed">
                      <Button
                        variant="contained"
                        color="error"
                        sx={{ ml: 2 }}
                        className={reportStyles.failedButton}
                        onClick={() => {
                          setSelectedFilter(TestStatus.FAIL);
                          setActive(true);
                        }}
                      >
                        {data?.testingResults['testng-results']?.failed}
                      </Button>
                    </Tooltip>
                    <Tooltip title="Skipped">
                      <Button
                        variant="contained"
                        sx={{ ml: 2 }}
                        className={style.skippedButton}
                      >
                        0
                      </Button>
                    </Tooltip>
                    <Tooltip title="Ignored">
                      <Button
                        variant="contained"
                        sx={{ ml: 2 }}
                        className={style.ignoredButton}
                      >
                        0
                      </Button>
                    </Tooltip>
                    <Button>
                      <Tooltip title="Show all details">
                        <FormatAlignLeftIcon />
                      </Tooltip>
                    </Button>
                  </Typography>

                </ListItem>
                <Collapse
                  in={active}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {renderData(data?.testingResults['testng-results']?.suite)}
                  </List>
                </Collapse>
              </>
            </List>
          )}
        </Grid>
        {openDrawer && <FullScreenModal
          tests={selectedTests}
          id={data?.id || ''}
          open={openDrawer}
          handleClose={() => setOpenDrawer(false)}
        />}
        {snackbar.state && (
          <NavigateSnackbar snackbarObj={snackbar} setSnackbar={setSnackbar} />
        )}
      </ParentBox>
    </>
  );
};

XmlReport.propTypes = {
  data: PropTypes.func.isRequired,
};

export default XmlReport;
